import React from 'react';
import { Edit, SimpleForm, TextInput, NumberInput, ImageInput, ImageField, required } from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';

export const ProductGroupEdit = (props: any) => {
    const propsObj: any = { ...props };

    if (propsObj.permissions) {
        const resourcename = `/${props.resource}`;
        const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
        if (myPermissions.length > 0) {
            debugger
            const p = myPermissions[0];
            propsObj.hasList = (p.View == 1) ? true : false;
          propsObj.hasShow = (p.View == 1) ? true : false;
          propsObj.hasEdit = (p.Edit == 1) ? true : false;
          propsObj.hasDelete = (p.Delete == 1) ? true : false;
          propsObj.hasCreate = (p.Create == 1) ? true : false;
          propsObj.hasExport = (p.Export == 1) ? true : false;
        }
        
    }

    return (
        <React.Fragment>
            <Edit title="Edit Product Group" {...propsObj} undoable={false}>
                <SimpleForm
                    warnWhenUnsavedChanges
                    redirect="list"
                    toolbar={<FormToolbar {...propsObj} />}
                    variant="outlined"
                >
                    <TextInput source="designCode" label="Design Code" fullWidth validate={[required()]} />
                    <TextInput source="designName" label="Design Name" fullWidth validate={[required()]} />
                    <NumberInput source="cartonCapacity" label="Carton Capacity" fullWidth />
                    <ImageInput fullWidth={true} source="imageurl" label="Photograph" accept="image/*">
                        <ImageField source="src" title="title" />
                    </ImageInput>
                    <ImageField source="photograph" title="photograph" />
                    
            
                </SimpleForm>
            </Edit>
        </React.Fragment>
    );
};
